<div (click)="toggleCheckbox()" class="aq-checkbox">
  <input [value]="isSelected" type="checkbox" [checked]="isSelected" [disabled]="disabled" />
  <div [ngClass]="{'yes': isSelected === true, 'no': isSelected === false, 'null': isSelected === null}"
    (changeEvent)="isSelected">
    <label></label>
  </div>
</div>
